<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4">Configurações Gerais</div>
      <v-row align="baseline" dense>
        <v-col cols="3">
          <v-switch dense class="ml-2" v-model="formConfig.khomp" label="Habilitar Khomp?" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="4">
          <v-text-field
            dense
            outlined
            v-model="formConfig.clienteName"
            label="Nome do Cliente"
            :counter="30"
            :error-messages="clienteNameErrors"
            @input="$v.formConfig.clienteName.$touch()"
            @blur="$v.formConfig.clienteName.$touch()"
          />
        </v-col>
        <v-col cols="4">
          <v-text-field dense outlined v-model="formConfig.directoryRecord" label="Caminho para gravação de áudio" />
        </v-col>
        <v-col cols="4">
          <v-text-field dense outlined v-model="formConfig.hostServerBackup" label="Endereço do server de backup" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field dense outlined v-model="formConfig.tokenBackup" label="Token do backup" />
        </v-col>
        <v-col class="ml-2 mt-n3">
          <v-radio-group v-model="formConfig.protocolDefault" row>
            <template v-slot:label>
              <div>Protocolo: </div>
            </template>
            <v-radio
                label="Padrão"
                value="padrao"
            ></v-radio>
            <v-radio
                label="Aleatório"
                value='aleatorio'
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'
import loginStore from '@/modules/login/_store'

import firewallStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import firewallHttpService from '../_services/firewallHttpService'

export default {
  name: 'ConfiguracaoGeral',
  components: { Snackbar, FixedButtons },
  data: () => ({
    pararLoader: {
      parar: false,
    },
    text: '',
    snackbar: false,
    showSkeleton: false,

    formConfig: {
      khomp: false,
      directoryRecord: '',
      tokenBackup: '',
      hostServerBackup: '',
      clienteName: '',
      protocolDefault: '',
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('mainConfigHomeModulePABXStore', ['getFirewallConfig']),
    ...mapGetters('clientNameStore', ['getClientName']),
    ...validateComputed,
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'mainConfigHomeModulePABXStore', firewallStore)
    registerVuexModule(this.$store, 'clientNameStore', loginStore)

    await this.listarConfiguracoesFirewall()
    this.formConfig = this.getFirewallConfig


    this.showSkeleton = false
  },

  methods: {
    ...mapActions('mainConfigHomeModulePABXStore', ['listarConfiguracoesFirewall']),
    ...mapActions('clientNameStore', ['injetarNomeDoCliente']),

    async salvar() {
      this.pararLoader.parar = false
      try {
          console.log(this.formConfig)
        await Promise.all([
          firewallHttpService.putFirewallConfig(this.formConfig),
          this.injetarNomeDoCliente(this.formConfig.clienteName),
        ])
        this.$router.push({ name: 'pabx' })
      } catch (error) {
        console.log(error.response)
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'pabx' })
    },
  },
}
</script>
